import { STORAGE_KEYS } from '@/constants/appIdentity'

const GATE_CB_PATTERN = /^\d{13}-[a-fA-F0-9]{6,8}$/
const GATE_CB_SESSION_KEY = STORAGE_KEYS.gateCb

export function isValidGateCb(value) {
  const cb = Array.isArray(value) ? value[0] : value
  return GATE_CB_PATTERN.test(String(cb || ''))
}

function randomHex(length = 6) {
  const size = Math.max(1, Number(length) || 6)
  const bytes = new Uint8Array(Math.ceil(size / 2))

  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes)
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256)
    }
  }

  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'))
    .join('')
    .slice(0, size)
}

export function generateGateCb() {
  return `${Date.now()}-${randomHex(6)}`
}

function saveGateCb(value) {
  try {
    sessionStorage.setItem(GATE_CB_SESSION_KEY, value)
  } catch {
    // sessionStorage 不可用时仍允许本次页面正常运行
  }
}

function getOrCreateGateCb() {
  try {
    const saved = sessionStorage.getItem(GATE_CB_SESSION_KEY)
    if (isValidGateCb(saved)) return saved
  } catch {
    // sessionStorage 不可用时生成新的 cb
  }

  const next = generateGateCb()
  saveGateCb(next)
  return next
}

export function ensureGateCbOnAddressBar(path) {
  const routePath = String(path || '')
  if (routePath === '/kfchat.html' || routePath.startsWith('/kfchat')) return

  const url = new URL(window.location.href)
  const currentCb = url.searchParams.get('cb')

  if (isValidGateCb(currentCb)) {
    saveGateCb(currentCb)
    return
  }

  url.searchParams.set('cb', getOrCreateGateCb())
  window.history.replaceState(
    window.history.state,
    '',
    `${url.pathname}${url.search}${url.hash}`
  )
}
